var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row",style:({'--grid-gutter': _vm.gutter, 'flex-wrap': _vm.wrap, 'align-items': _vm.verticalAlign, 'justify-content': _vm.horizontalAlign})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }